import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Radio, RadioChangeEvent, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { requiredIdentifier } from "../../Models/FIPModel";
import { identifier } from "../../Models/Request/Identifier/AddIdentifier";
import { GetIdentifierResponse } from "../../Models/Response/Identifier/Identifier";
import {
  addIdentifier,
  addIdentifierVerification,
  getIdentifiers,
} from "../../Services/IdentifierService/Identifier";
import { StrongIdentifier } from "../../Utils/Constants/identifierType";
import "./index.css";
import AddUserIdentification from "./UserIdentification";

interface IIdentifiersProps {
  onRadioSelect: (e: any) => void;
  onSelectIdentifier: () => void;
  requiredIdentifier: requiredIdentifier[];
}

const Identifiers: React.FC<IIdentifiersProps> = ({
  onRadioSelect,
  onSelectIdentifier,
  requiredIdentifier,
}) => {
  const [identifiers, setIndentifiers] = useState([
    { type: "", value: "", categoryType: "" },
  ]);
  const [visible, setVisibility] = useState(false);
  const [isAddIdentifierVerification, setVerification] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [selectedIdentifier, setSelectedIdentifier] = useState<any>({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [defaultAddIdentifier, setDefaultAddIdentifier] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    const linkedTypes = new Set(
      identifiers.map((identifier) => identifier.type)
    );
    const selectedType = new Set(Object.keys(selectedIdentifier));
    requiredIdentifier.forEach((identifier) => {
      if (!linkedTypes.has(identifier.type)) {
        setDefaultAddIdentifier(identifier);
      } else {
        setDefaultAddIdentifier({});
      }
    });
    if (
      requiredIdentifier.every((identifier) =>
        linkedTypes.has(identifier.type)
      ) &&
      requiredIdentifier.every((identifier) =>
        selectedType.has(identifier.type)
      )
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [identifiers, selectedIdentifier]);

  useEffect(() => {
    getIdentifiers()
      .then((res) => res.data)
      .then((res) => {
        setIndentifiers(res);
        // onRadioSelect([res[0]]);
        // setSelectedIdentifier(res[0]);
      });
  }, [onRadioSelect]);

  const onCancel = () => {
    setVisibility(false);
    setVerification(false);
  };

  const onIdentifierEntered = (iNumber: any) => {
    addIdentifier(iNumber)
      .then((res) => res.data)
      .then((res) => {
        if (iNumber.type === StrongIdentifier.MOBILE) {
          setVerification(true);
          setOTPUniqueId(res.mobile.otpUniqueID);
        } else {
          setVisibility(false);
          getIdentifiers()
            .then((res) => res.data)
            .then((res) => setIndentifiers(res));
        }
      });
  };

  const onOTPSubmit = (otp: string, identifierNumber: identifier) => {
    addIdentifierVerification({
      phoneNumber: identifierNumber.value,
      identifierType: identifierNumber.type,
      code: otp,
      otpUniqueID,
    }).then(() => {
      getIdentifiers()
        .then((res) => res.data)
        .then((res) => setIndentifiers(res));
      setVisibility(false);
      setVerification(false);
    });
  };
  useEffect(() => {
    onRadioSelect(Object.values(selectedIdentifier));
  }, [selectedIdentifier]);

  const identifierSelectionChange = (e: RadioChangeEvent, type: any) => {
    const localIdentifier = identifiers.filter(
      (i: any) => i.value === e.target.value
    );

    setSelectedIdentifier((prev: any) => ({
      ...prev,
      [type]: {
        value: localIdentifier[0].value,
        categoryType: localIdentifier[0].categoryType,
        type: type,
      },
    }));
  };

  const setModalVisibility = () => {
    setVisibility(true);
  };
  const renderIdentifiers = (requiredIdentifier: any) => {
    return (
      <div className="radioSection">
        <Typography.Text>{requiredIdentifier.type}</Typography.Text>
        {identifiers.filter(
          (identifier) => identifier.type === requiredIdentifier.type
        ).length > 0 ? (
          <Radio.Group
            className="radioGroupIdentifier"
            value={selectedIdentifier[requiredIdentifier.type]?.value}
            onChange={(e) =>
              identifierSelectionChange(e, requiredIdentifier.type)
            }
          >
            {identifiers &&
              identifiers
                .filter(
                  (identifier) => identifier.type === requiredIdentifier.type
                )
                .map((singleIdentifier: GetIdentifierResponse, index) => (
                  <Card key={index} className="accountCard identifierCard">
                    <Radio value={singleIdentifier.value}>
                      {singleIdentifier.value}
                    </Radio>
                  </Card>
                ))}
          </Radio.Group>
        ) : (
          <>
            <Typography.Text style={{ color: "red" }}>
              {`${requiredIdentifier.type} is required for account discover.`}
            </Typography.Text>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="identifierRoot">
      <Typography.Text className="typoGraphyIdentifier">
        {t("Identifiers linked to your AA account")}
      </Typography.Text>
      {requiredIdentifier &&
        requiredIdentifier.map((requiredIdentifier) =>
          renderIdentifiers(requiredIdentifier)
        )}

      <Button
        className="addIdentifier"
        onClick={setModalVisibility}
        type="text"
        icon={<PlusOutlined />}
      >
        {t("ADD Identifier")}
      </Button>
      <Button
        className="primaryButton customizeButton"
        onClick={onSelectIdentifier}
        disabled={isDisabled}
      >
        {t("Continue")}
      </Button>
      <AddUserIdentification
        visible={visible}
        handleCancel={onCancel}
        identifierEntered={onIdentifierEntered}
        onOTPSubmit={onOTPSubmit}
        isAddIdentifierVerification={isAddIdentifierVerification}
        label={"Add Identifier"}
        multipleIdentifiers={true}
        requiredCategory={requiredIdentifier.map((i) => i.category)}
        requiredType={requiredIdentifier.map((i) => i.type)}
        defaultAddIdentifier={defaultAddIdentifier}
      />
    </div>
  );
};
export default Identifiers;
